// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__1TGuV","box":"WorkspacesBox_box__1KGpR","node":"WorkspacesBox_node__-o--2"};